class GtcPagination extends HTMLElement {
  constructor() {
    super();

    const dataElement = this.querySelector("[data-data]");
    if (!dataElement) {
      return;
    }

    this.data = JSON.parse(dataElement.textContent);

    this.gridSelector = this.querySelector(
      "[data-grid-selector]"
    ).dataset.gridSelector;

    this.grid = document.querySelector(this.gridSelector);

    this.count = this.querySelector("[data-count]");
    this.progress = this.querySelector("[data-progress]");
    this.previousButton = this.querySelector("[data-previous]");
    this.nextButton = this.querySelector("[data-next]");

    this.parts = new Map();

    for (let i = 0; i < this.data.pages; i += 1) {
      const page = i + 1;
      const size =
        (i === this.data.pages - 1
          ? this.data.items % this.data.page_size
          : this.data.page_size) || this.data.page_size;
      const url = new URL(window.location.toString());
      url.searchParams.append("page", (i + 1).toString());
      url.searchParams.append("view", "items");

      this.parts.set(page, {
        page,
        size,
        url,
        isLoaded: page === this.data.current_page,
      });
    }

    this.previousPart = this.parts.get(this.data.current_page - 1);
    this.nextPart = this.parts.get(this.data.current_page + 1);
  }

  updateProgress = () => {
    let currentOffset = 0;
    let currentProgress = 0;
    let hasFoundLoadedPart = false;

    this.parts.forEach((part) => {
      if (part.isLoaded) {
        currentProgress += part.size;
        hasFoundLoadedPart = true;
      }

      if (!hasFoundLoadedPart) {
        currentOffset += part.size;
      }
    });

    this.count.textContent = currentProgress.toString();
    this.progress.style.setProperty(
      "--progress",
      `${(currentProgress / this.data.items) * 100}%`
    );
    this.progress.style.setProperty(
      "--offset",
      `${(currentOffset / this.data.items) * 100}%`
    );
  };

  updatePageParam = (part) => {
    const params = new URLSearchParams(window.location.search);
    params.set("page", part.page.toString());

    window.history.replaceState(null, "", `?${params.toString()}`);
  };

  loadPart = async (part) => {
    if (part.isLoaded) {
      throw new Error("Pagination part is already loaded or loading");
    }

    part.isLoaded = true;
    this.updateProgress();

    const response = await fetch(part.url);
    return response.text();
  };

  insertItems = (position, text, autoFocus) => {
    this.grid.role = "alert";

    const content = document.createElement("div");
    content.insertAdjacentHTML(
      position === "previous" ? "afterbegin" : "beforeend",
      text
    );
    const children = Array.from(content.children);

    if (position === "previous") {
      this.grid.prepend(...children);

      if (autoFocus) {
        children[children.length - 1]
          ?.querySelector("a, button, input, select, textarea")
          ?.focus();
      }
    } else {
      this.grid.append(...children);

      if (autoFocus) {
        children[0]
          ?.querySelector("a, button, input, select, textarea")
          ?.focus();
      }
    }

    const productsLoaded = new CustomEvent("products:loaded");
    window.dispatchEvent(productsLoaded);
  };

  loadPrevious = async (event) => {
    if (!this.previousPart) {
      return;
    }

    if (event) {
      this.updatePageParam(this.previousPart);
    }

    this.insertItems(
      "previous",
      await this.loadPart(this.previousPart),
      event !== undefined
    );

    this.previousPart = this.parts.get(this.previousPart.page - 1);

    if (!this.previousPart && this.previousButton) {
      this.previousButton.remove();
    }
  };

  loadNext = async (event) => {
    if (!this.nextPart) {
      return;
    }

    if (event) {
      this.updatePageParam(this.nextPart);
    }

    this.insertItems(
      "next",
      await this.loadPart(this.nextPart),
      event !== undefined
    );

    this.nextPart = this.parts.get(this.nextPart.page + 1);

    if (!this.nextPart && this.nextButton) {
      this.nextButton.remove();
    }
  };

  connectedCallback() {
    this.previousButton?.addEventListener(
      "click",
      this.loadPrevious.bind(this)
    );
    this.nextButton?.addEventListener("click", this.loadNext.bind(this));

    if (this.hasAttribute("data-autoload-previous")) {
      while (this.previousPart) {
        this.loadPrevious();
      }
    }
  }
}

customElements.define("gtc-pagination", GtcPagination);
